import { z } from 'zod';
import { ApiResponse, ErrorResponse } from '@/shared/types';
import { axiosClient } from '@/shared/apis/config';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

// ================================ Start: DTO ================================
export const PatchProjectSettingRequestScheme = z.object({
  accountBrandTemplateId: z.number().nullable().optional(),
  clearBrandTemplate: z.boolean().optional(),
  voice: z.string().optional(),
  speedFactor: z.number(),
  pitch: z.number(),
  emotion: z.string(),
  /** Gemini 전용 자연어 스타일 지시 (다른 벤더는 무시). */
  style: z.string().optional(),
});

export type PatchProjectSettingRequestType = z.infer<
  typeof PatchProjectSettingRequestScheme
>;
// ================================= End: DTO =================================

type Response = ApiResponse<void>;

export const patchProjectSettingApi = async (
  projectId: number,
  body?: PatchProjectSettingRequestType,
) => {
  try {
    const response = await axiosClient.patch<Response>(
      `/v1.0/project/${projectId}/setting`,
      body,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usePatchProjectSettingApi = () => {
  return useMutation<
    Response,
    AxiosError<ErrorResponse>,
    { projectId: number; body?: PatchProjectSettingRequestType }
  >({
    mutationFn: ({ projectId, body }) =>
      patchProjectSettingApi(projectId, body),
  });
};
